import { render, staticRenderFns } from "./InvoicesReportTemplate.vue?vue&type=template&id=a98421ec"
import script from "./InvoicesReportTemplate.vue?vue&type=script&lang=js"
export * from "./InvoicesReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports